import './LunchPreviewSection.scss';
import PropTypes from "prop-types";

const LunchPreviewSection = ({title, text}) => (
    <div className="lunch-preview-section">
        <div className="lunch-preview-section__separator"/>
        <div className="lunch-preview-section__content">
            {title && <div className="lunch-preview-section__title">{title}</div>}
            {text && <div className="lunch-preview-section__text">{text}</div>}
        </div>
    </div>
);

LunchPreviewSection.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string
};

export default LunchPreviewSection;
